module.exports = __webpack_public_path__ + "static/media/RAM_Single_Control_Point.2260f8d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/RAM_Single_Control_Point.svg
// module id = 946
// module chunks = 0